import useAnalytics from "../hooks/useAnalytics"

const Analytics  = () => {
  useAnalytics();

  return ''
}

export default Analytics